export enum SquidexProductTileLinkTypes {
  EXTERNAL_LINK = "zewnętrzne",
  INTERNAL_LINK = "wewnętrzne",
}

export enum SquidexProductTilePriceTypes {
  PRICE_PLAN_TYPE = "plan",
  PRICE_CUSTOM_TYPE = "statyczna",
}
